var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.81,
    height: 15.81,
    viewBox: "0 0 15.81 15.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M18.214.948a1.746,1.746,0,0,0-2.471,0l-.939.936,3.055,3.055L18.8,4a1.746,1.746,0,0,0,0-2.471ZM8.879,7.812a1.724,1.724,0,0,0-.421.683l-.924,2.771a.753.753,0,0,0,.181.768.743.743,0,0,0,.768.181l2.771-.924a1.806,1.806,0,0,0,.683-.421l5.22-5.223L14.1,2.589ZM6.5,2.268a3,3,0,0,0-3,3V13.25a3,3,0,0,0,3,3h7.987a3,3,0,0,0,3-3v-3a1,1,0,0,0-2,0v3a1,1,0,0,1-1,1H6.5a1,1,0,0,1-1-1V5.263a1,1,0,0,1,1-1h3a1,1,0,0,0,0-2Z",
    transform: "translate(-3.5 -0.435)",
    fill: "#ff4e00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditFill);
export default __webpack_public_path__ + "static/media/edit-fill.0a2671c083e8f1a47290e37fed2d452f.svg";
export { ForwardRef as ReactComponent };